import React from "react";
import { Client } from "@/lib/types/database";

interface ClientOtherInfoProps {
  client: Client;
  variant?: "default" | "compact";
  showTitle?: boolean;
}

export const ClientOtherInfo: React.FC<ClientOtherInfoProps> = ({
  client,
  variant = "default",
  showTitle = true,
}) => {
  const isCompact = variant === "compact";

  const content = (
    <div className={isCompact ? "space-y-1" : "space-y-3"}>
      {client.notes && (
        <div>
          <p className={`${isCompact ? "text-xs" : "text-sm"} font-medium text-gray-500`}>
            {isCompact ? "Notes" : "Notes"}
          </p>
          <p
            className={`${isCompact ? "text-sm" : "text-base"} text-card-foreground whitespace-pre-line`}
          >
            {client.notes}
          </p>
        </div>
      )}

      {client.social_links && Object.keys(client.social_links).length > 0 && (
        <div>
          <p className={`${isCompact ? "text-xs" : "text-sm"} font-medium text-gray-500`}>
            {isCompact ? "Social" : "Social Links"}
          </p>
          <div className="flex flex-wrap gap-2">
            {Object.entries(client.social_links).map(([platform, url]) => (
              <a
                key={platform}
                href={url as string}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center px-2 py-1 rounded text-xs font-medium bg-card-100 text-gray-800 hover:bg-card-200 dark:text-gray-200"
              >
                {platform}
              </a>
            ))}
          </div>
        </div>
      )}

      {client.custom_fields && Object.keys(client.custom_fields).length > 0 && (
        <div>
          <p className={`${isCompact ? "text-xs" : "text-sm"} font-medium text-gray-500`}>
            {isCompact ? "Custom" : "Custom Fields"}
          </p>
          <div className="space-y-1">
            {Object.entries(client.custom_fields).map(([key, value]) => (
              <div key={key} className="flex justify-between">
                <span className={`${isCompact ? "text-xs" : "text-sm"} text-gray-600 capitalize dark:text-gray-400`}>
                  {key.replace(/_/g, " ")}:
                </span>
                <span className={`${isCompact ? "text-xs" : "text-sm"} text-card-foreground`}>
                  {String(value)}
                </span>
              </div>
            ))}
          </div>
        </div>
      )}

      <div>
        <p className={`${isCompact ? "text-xs" : "text-sm"} font-medium text-gray-500`}>
          {isCompact ? "Created" : "Created At"}
        </p>
        <p className={`${isCompact ? "text-sm" : "text-base"} text-card-foreground`}>
          {client.created_at ? new Date(client.created_at).toLocaleString() : "-"}
        </p>
      </div>
      <div>
        <p className={`${isCompact ? "text-xs" : "text-sm"} font-medium text-gray-500`}>
          {isCompact ? "Updated" : "Updated At"}
        </p>
        <p className={`${isCompact ? "text-sm" : "text-base"} text-card-foreground`}>
          {client.updated_at ? new Date(client.updated_at).toLocaleString() : "-"}
        </p>
      </div>
    </div>
  );

  if (!showTitle) {
    return content;
  }

  return (
    <div>
      <h2 className={`${isCompact ? "text-sm" : "text-lg"} font-semibold mb-4`}>
        {isCompact ? "Other" : "Other Information"}
      </h2>
      {content}
    </div>
  );
};
